import React, { FC } from "react";
import { ApplicationProductEnum } from "enums/application-product.enum";
import { PremiumFeatureBlock } from "routes/dashboard/components/PremiumFeatureBlock/PremiumFeatureBlock";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { observer } from "mobx-react";
import { AccountIntegrations } from "./AccountIntegrations";
import { IntegrationsSplashScreen } from "./IntegrationsSplashScreen/IntegrationsSplashScreen";

interface IProps {
  accountStore: UserAccountStore;
}

export const AccountIntegrationsGuard: FC<IProps> = observer(
  ({ accountStore }) => {
    return (
      <PremiumFeatureBlock
        productId={ApplicationProductEnum.INTEGRATIONS_TAB}
        render={isEnabled => (
          <AccountIntegrations accountStore={accountStore} />
        )}
        alternativeRender={() => (
          <IntegrationsSplashScreen accountStore={accountStore} />
        )}
      />
    );
  }
);
